import { verifyBoligagent } from '../redux/modules/boligagents';
import { connect } from 'react-redux';
import { addAlert } from '../redux/modules/app';
import { setSearchQuery } from '../redux/modules/search';
import Verify from './verify';

export default connect(
  () => ({}),
  { verifyBoligagent, addAlert, setSearchQuery }
)(Verify);
